import { HTTP } from "@/service/axios.js";
export default{
	data(){
		return {
			maxWidth: window.innerWidth,
		}
	},
	methods:{
		setTheme(user){
			HTTP.defaults.headers.common.Authorization = `Bearer ${user.token}`;
    		HTTP.get(`/template/${user._id}`).then(res=>{
    			if(res.data.success){
    				if(typeof res.data.obj.template != 'undefined'){
						let setBg = {
							label:'backGround',
							child:'color',
							value: user.userLevel == 60 ? res.data.obj.template.themeAdmin : res.data.obj.template.themeStaff 
						}
						this.$store.commit('SET_THEME',setBg)
						let setBt = {
							label:'button',
							child:'backGroundColor',
							value: user.userLevel == 60 ? res.data.obj.template.buttonAdmin : res.data.obj.template.buttonStaff
						}
						this.$store.commit('SET_THEME',setBt)
						let setBtHover = {
							label:'button',
							child:'backGroundColorHover',
							value:user.userLevel == 60 ? res.data.obj.template.buttonAdmin : res.data.obj.template.buttonStaff
						}
						this.$store.commit('SET_THEME',setBtHover)
						let setTitle = {
							label:'text',
							child:'title',
							value:res.data.obj.template.departmentName
						}
						this.$store.commit('SET_THEME',setTitle)
						let setSubtitle = {
							label:'text',
							child:'subTitle',
							value:res.data.obj.template.description
						}
						this.$store.commit('SET_THEME',setSubtitle)
						let setLogo = {
							label:'text',
							child:'logo',
							value:res.data.obj.template.logo
						}
						this.$store.commit('SET_THEME',setLogo)
					}
				}
			})
		},
		setDefaultTheme(user){
			let setBg = {
				label:'backGround',
				child:'color',
				value: '#00A79D'
			}
			this.$store.commit('SET_THEME',setBg)
			let setBt = {
				label:'button',
				child:'backGroundColor',
				value: '#00A79D'
			}
			this.$store.commit('SET_THEME',setBt)
			let setBtHover = {
				label:'button',
				child:'backGroundColorHover',
				value:'#038880'
			}
			this.$store.commit('SET_THEME',setBtHover)
			let setTitle = {
				label:'text',
				child:'title',
				value:'ระบบสร้าง และ บริหารฟอร์มแบบออนไลน์'
			}
			this.$store.commit('SET_THEME',setTitle)
			let setSubtitle = {
				label:'text',
				child:'subTitle',
				value:'Anytime, Customize and Easy to use'
			}
			this.$store.commit('SET_THEME',setSubtitle)
			let setLogo = {
				label:'text',
				child:'logo',
				value:'logo-ace-form.png'
			}
			this.$store.commit('SET_THEME',setLogo)
		}
	},
	computed:{
		user(){
			return this.$store.state.user
		},
		formData(){
			return this.$store.state.form
		},
		theme(){
			return this.$store.state.theme
		},
	    styleObject() {
	      return {
	        '--button-color': this.theme.button.color,
	        '--button-color--hover': this.theme.button.colorHover,
	        '--button-background-color': this.theme.button.backGroundColor,
	        '--button-background-color--hover': this.theme.button.backGroundColorHover,
	        '--button-border-color': this.theme.button.borderColor,
	        '--button-border-color--hover': this.theme.button.borderColorHover
	      }
	    },
	},
}